module.exports = __webpack_public_path__ + "favicon.dc4cf7231d95d00b429035e4b899da5e.png";